export class ProjectReleatedProfilesRelationTypeEnum {
    constructor() {
        this.NO_DEFINIDO = 0;
        this.CONYUGUE_PAREJA_CONCUBINATO = 1;
        this.FAMILIAR_PRIMER_GRADO = 2;
        this.FAMILIAR_SEGUNDO_GRADO = 3;
        this.SOCIO_NEGOCIOS = 4;
        this.AMIGOS = 5;
    }

    toArray() {
        return {
            [this.NO_DEFINIDO]: "No definido",
            [this.CONYUGUE_PAREJA_CONCUBINATO]: "Cónyugue, Pareja o Concubino(a)",
            [this.FAMILIAR_PRIMER_GRADO]: "Familia primar grado (padres, hijos o hermanos)",
            [this.FAMILIAR_SEGUNDO_GRADO]: "Tio(a), primo(a), sobrino(a), abuelo(a), nieto(a)",
            [this.SOCIO_NEGOCIOS]: "Socio de negocios, comercial",
            [this.AMIGO]: "Amigo(a) o conocido",
        }
    }
}